import { SongData } from 'services/store/distribution/types';
import { SongsListItem } from './components';
import { StyledList } from './styled';

type PropsType = {
  songsData: SongData[];
};

const SongsList = ({ songsData }: PropsType) => (
  <StyledList>
    {songsData.map((song) => (
      <SongsListItem key={song.id} song={song} />
    ))}
  </StyledList>
);

export default SongsList;
